module.exports = __webpack_public_path__ + "static/media/merbau.9883d83e.jpg";